"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _utils = require("composer-lib/components/clips/utils");

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _default = (0, _createReactClass.default)({
  displayName: "AttributionEditButton",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    attribution: _propTypes.default.string,
    closePopover: _propTypes.default.func.isRequired,
    isCollectBeta: _propTypes.default.bool,
    openPopover: _propTypes.default.bool.isRequired,
    togglePopover: _propTypes.default.func.isRequired,
    updateAttribution: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      attribution: this.props.attribution,
      termsAccepted: false
    };
  },
  changeAttribution: function changeAttribution(e) {
    this.setState({
      attribution: e.target.value
    });
  },
  saveAttribution: function saveAttribution() {
    var _this$props = this.props,
        closePopover = _this$props.closePopover,
        updateAttribution = _this$props.updateAttribution;
    (0, _UsageTracking.trackEvent)({
      action: 'manage-collect',
      extra: {
        'manage-collect': 'edit-attribution'
      },
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.USAGE
    });
    updateAttribution(this.state.attribution);
    closePopover();
  },
  toggleTermsAccepted: function toggleTermsAccepted() {
    this.setState(function (prevState) {
      return {
        termsAccepted: !prevState.termsAccepted
      };
    });
  },
  renderTermsAndConditionsCheckbox: function renderTermsAndConditionsCheckbox() {
    if (this.props.isCollectBeta) {
      return null;
    }

    var termsAccepted = this.state.termsAccepted;
    var options = {
      closeLink: _I18n.default.SafeString('</a>'),
      openLink: _I18n.default.SafeString("<a href=\"" + _constants.TERMS_AND_CONDITIONS_URL + "\" target=\"_blank\">")
    };
    return _react.default.createElement(_UICheckbox.default, {
      checked: termsAccepted,
      className: "attribution-checkbox",
      onChange: this.toggleTermsAccepted
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: (0, _utils.clipsLangKey)('attribution.terms'),
      options: options
    }));
  },
  renderPopoverContent: function renderPopoverContent() {
    var _this$props2 = this.props,
        closePopover = _this$props2.closePopover,
        isCollectBeta = _this$props2.isCollectBeta;
    var _this$state = this.state,
        attribution = _this$state.attribution,
        termsAccepted = _this$state.termsAccepted;
    return {
      header: _react.default.createElement("h4", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.edit.header')
      })),
      body: _react.default.createElement("span", null, !isCollectBeta && _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.edit.body')
      }), _react.default.createElement(_UITextInput.default, {
        className: "m-bottom-4",
        onChange: this.changeAttribution,
        placeholder: _I18n.default.text((0, _utils.clipsLangKey)('attribution.edit.input.placeholder')),
        value: attribution
      }), this.renderTermsAndConditionsCheckbox()),
      footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
        disabled: !(attribution && termsAccepted || isCollectBeta),
        onClick: this.saveAttribution,
        use: "primary"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.edit.button.submit')
      })), _react.default.createElement(_UIButton.default, {
        onClick: closePopover,
        use: "tertiary-light"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.edit.button.cancel')
      })))
    };
  },
  render: function render() {
    var _this$props3 = this.props,
        openPopover = _this$props3.openPopover,
        togglePopover = _this$props3.togglePopover;
    return _react.default.createElement(_UIPopover.default, {
      content: this.renderPopoverContent(),
      open: openPopover,
      use: "shepherd",
      width: 350
    }, _react.default.createElement(_UIIcon.default, {
      className: "pointer",
      color: colors.CALYPSO,
      onClick: togglePopover,
      name: "edit"
    }));
  }
});

exports.default = _default;
module.exports = exports.default;